/* OLVR ring builder: photos behind a button on phones (Oct 23, 2026).
   Loaded only on the ring builder, from the custom liquid block in
   templates/product.builder.json. Remove that script tag to undo (and the
   "Photos button on phones" CSS in assets/olvr-builder-tweaks.css).

   On phones the 360 is always full width and the strip of photo thumbnails
   on the right is hidden (it used to show on every step except hidden stone
   and engraving). A round button sits bottom left of the 360, across from the
   360 badge: a tiny photo of the ring (on model if there is one, else through
   finger) with the number of photos on it. Tapping it slides the thumbnail
   strip in over the right side of the 360; tap a thumbnail to see that photo, the 360 thumbnail to go
   back. Tapping the button again, or Next / Back, closes the strip and goes
   back to the 360. Desktop is unchanged. */
(function () {
  if (window.__olvrPhotos) return;
  window.__olvrPhotos = true;

  var OPEN = 'olvr-photos-open';
  var mq = window.matchMedia('(max-width: 749px)');

  /* Which photo goes on the button, best first. Matched against the file name,
     e.g. NOVA-001-OV200.OnModel.White.jpg, NOVA-002-CU200.Through_Finger.Rose.jpg */
  var PICK = [/\.OnModel\./i, /\.Through_?Finger\./i];
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function stills(g) {
    return Array.prototype.filter.call(g.querySelectorAll('.thumbnail-slider li img'), function (img) {
      return !img.closest('li[data-target$="-viewer"]') && !/3D Viewer/i.test((img.closest('li') && img.closest('li').textContent) || '') && !(img.closest('button') && /3D Viewer/i.test(img.closest('button').getAttribute('aria-label') || ''));
    });
  }

  function bestPhoto(list) {
    var name = function (img) { return (img.getAttribute('src') || '').split('?')[0].split('/').pop(); };
    for (var i = 0; i < PICK.length; i++) {
      for (var j = 0; j < list.length; j++) if (PICK[i].test(name(list[j]))) return list[j];
    }
    return list[0] || null;
  }

  /* The photo and count follow the ring that's picked (the thumbnails change
     with each pick). */
  function photosFace(g) {
    var list = stills(g);
    var img = bestPhoto(list);
    if (!img) return '';
    var src = img.currentSrc || img.getAttribute('src');
    return '<img src="' + src + '" alt="" aria-hidden="true"><b>' + list.length + '</b>';
  }

  function paint(btn, g) {
    var open = document.body.classList.contains(OPEN);
    var html = open ? ICON_CLOSE : photosFace(g);
    if (btn.__face !== html) { btn.innerHTML = html; btn.__face = html; }
    btn.classList.toggle('is-open', open);
  }

  function gallery() { return document.querySelector('body.template-product-builder media-gallery'); }

  function showViewer() {
    var g = gallery();
    if (g && g.setActiveMedia && g.dataset.sectionId) {
      try { g.setActiveMedia(g.dataset.sectionId + '-viewer', false); } catch (e) {}
    }
  }

  function setOpen(open) {
    var was = document.body.classList.contains(OPEN);
    if (was === open) return;
    if (!open) showViewer();
    document.body.classList.toggle(OPEN, open);
    var btn = document.querySelector('.olvr-photos-btn');
    var g = gallery();
    if (btn && g) {
      paint(btn, g);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Hide photos' : 'See photos');
    }
  }

  function ensureButton() {
    if (!mq.matches) return;
    var g = gallery();
    if (!g) return;
    var have = g.querySelector('.olvr-photos-btn');
    if (have) { paint(have, g); return; }
    if (!stills(g).length) return; /* no photos, no button */
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'olvr-photos-btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'See photos');
    g.appendChild(btn);
    /* the gallery was swapped out (another style picked): start closed */
    if (document.body.classList.contains(OPEN)) {
      document.body.classList.remove(OPEN);
    }
    paint(btn, g);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.olvr-photos-btn')) {
      e.preventDefault();
      setOpen(!document.body.classList.contains(OPEN));
      return;
    }
    if (t.closest('#step-next, #step-prev')) setOpen(false);
  });

  /* Leaving phone width (rotating a tablet, resizing) closes it. */
  if (mq.addEventListener) mq.addEventListener('change', function () { setOpen(false); ensureButton(); });

  function start() {
    ensureButton();
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(ensureButton, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Shop Pay logo in the black summary band (Oct 26, 2026). Shopify draws the
   "From $X/mo with Shop" line itself and turns the Shop logo white on its own
   when the text around it is white. It got lost on the black band, so the logo
   now sits on a small Shop-purple badge in white, like the Shop Pay button at
   checkout (Daryl picked this over a lighter purple logo). Shopify redraws the
   line on every pick, so this reapplies each time. Delete this block to go
   back to the plain white logo. */
(function () {
  if (window.__olvrShopPurple) return;
  window.__olvrShopPurple = true;

  /* KNOB: badge look. #5433EB is Shop's purple. */
  var BADGE_CSS = 'color:#fff !important;background-color:rgb(84, 51, 235);border-radius:4px;padding:2px 4px;margin-left:2px;';
  var BADGE_RGB = 'rgb(84, 51, 235)';

  function fix(pt) {
    var sr = pt.shadowRoot;
    if (!sr) return;
    sr.querySelectorAll('svg title').forEach(function (t) {
      if (!/shop/i.test(t.textContent)) return;
      var d = t.closest('div') || t.parentNode.parentNode;
      if (d && d.style && d.style.backgroundColor !== BADGE_RGB) {
        d.style.cssText = BADGE_CSS;
      }
    });
    if (!pt.__olvrWatch) {
      pt.__olvrWatch = true;
      new MutationObserver(function () { fix(pt); }).observe(sr, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    }
  }

  function scan() {
    document.querySelectorAll('shopify-payment-terms').forEach(fix);
  }

  function start() {
    scan();
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(scan, 100);
    }).observe(document.body, { childList: true, subtree: true });
    setTimeout(scan, 1000);
    setTimeout(scan, 3000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
